export default "__VITE_ASSET__325433a4__"